module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1556.da504013.jpg";